(() => {
	const offcanvasCloseBtns = document.querySelectorAll('.offcanvas__close');
	const offcanvasBackdrops = document.querySelectorAll('.offcanvas__backdrop');
	const offcanvasTriggers = document.querySelectorAll('.toggle-of-canvas-menu');

	offcanvasTriggers.forEach(trigger => {
		trigger.addEventListener('click', function(e) {
			e.preventDefault();
			const target = e.target.dataset.offcanvasTarget;
			if(target) {
				openCanvasMenu(target);
			}
		});
	});
	
	offcanvasBackdrops.forEach(backdrop => {
		backdrop.addEventListener('click', function() {
			closeCanvasMenu();	
		});
	});

	offcanvasCloseBtns.forEach(btn => {
		btn.addEventListener('click', function() {
			closeCanvasMenu();	
		});
	});
	
})();

const openCanvasMenu = target => {
	const offcanvas = document.querySelector(`.offcanvas[name="${target}"]`);
	const backdrop = document.querySelector(`.offcanvas__backdrop[name="${target}"]`);
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
	document.body.classList.add('offcanvas-active');
	backdrop.classList.add('offcanvas__backdrop--active');
	offcanvas.classList.add('offcanvas--open');
};

const closeCanvasMenu = () => {
	const offcanvases = document.querySelectorAll('.offcanvas');
	const backdrops = document.querySelectorAll('.offcanvas__backdrop');
	document.body.style.setProperty('--scrollbar-width', '0');
	document.body.classList.remove('offcanvas-active');
	offcanvases.forEach(el => el.classList.remove('offcanvas--open'));
	backdrops.forEach(el => el.classList.remove('offcanvas__backdrop--active'));
};

export {
	openCanvasMenu,
	closeCanvasMenu
};